import logger from "../utils/logger";

export default class CommunityObject {
  constructor(objectType) {
    this.objectType = objectType;
    this.validationErrors = [];
  }
  validate() {
    let errorsToken = [];
    Object.keys(this).forEach(function(key, value) {
      if (!value && (key != "validationErrors" && key != "objectType")) {
        errorsToken.push("Missing or invalid value for the property: ", key);
      }
    });
    this.validationErrors = errorsToken;
    if (this.validationErrors.length > 0) {
      logger.warn(
        "object.validation_failed",
        "Validation errors with object: " + this.objectType,
        { objectType: this.objectType, validationErrors: this.validationErrors }
      );
      console.table(this.validationErrors);
    }
  }
}
